module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"pageNotFound":"That page couldn\u0027t be found.","goBack":"Go back to homepage"},"fr":{"pageNotFound":"Cette page n\u0027a pas pu être trouvée.","goBack":"Retour à la page d\u0027accueil."}}')
  delete Component.options._Ctor
}
